
import { ChangeDetectionStrategy, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { NetworkService } from '@fry-it/risr-core';
import { setAngularJSGlobal } from '@angular/upgrade/static';
import angular from 'angular';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    providers: [
    ]
})
export class AppComponent {

  @ViewChild('kaizen') kaizenEl: ElementRef;

  private sw = inject(SwUpdate);
  private network = inject(NetworkService);

  constructor() {
    this.network.resetMode();
    this.setupServiceWorker();
    setAngularJSGlobal(angular);
  }

  setupServiceWorker(): void {
    console.log("SW", this.sw.isEnabled);
    window['offlineState'] = {
      engine: 'serviceWorker',
      state: this.sw.isEnabled ? 'ready' : 'none',
    }

    this.sw.versionUpdates.subscribe(event => {
      console.log("SW", event);
      console.log("SW", this.sw.isEnabled);
    });
    this.sw.unrecoverable.subscribe(event => {
      console.log("SW", event);
    });
  }

}
